import React, { useContext } from 'react';
import { useTranslation } from "react-i18next";
import SidebarNavigationButton from "../../../components/SidebarNavigationButton/SidebarNavigationButton";
import { useAppSelector } from "../../../../../../app/store";
import { selectCurrentUser } from "../../../../../../features/authentication/authenticationSliceSelectors";
import { UserRole } from "../../../../../../app/enums/UserRole";
import { getUserRole } from "../../../../../../helpers/user";
import SidebarNavigationNestedButton
    from "../../../components/SidebarNavigationButton/SidebarNavigationNestedButton/SidebarNavigationNestedButton";
import { SidebarContext } from "../../../Sidebar";
import { isMobile } from "react-device-detect";
import SidebarButton from '../../../components/SidebarButton/SidebarButton';
import { useDataHelperApi } from '../../../../../../app/api/dataHelper';


const SidebarMenuSanctionsCheck: React.FC = ({ }) => {
    const { t } = useTranslation();
    const user = useAppSelector(selectCurrentUser);

    const {
        getSanctionsCheckLink: {
            query: getSanctionsCheckLink
        }
    } = useDataHelperApi();

    const openSanctionsCheckLink = async () => {

        try {
            const response = await getSanctionsCheckLink();
            if (response?.status === 200 && response.data && response.data) {
                return response.data;
            }

        } catch {
            //ignore
        }
    }

    if (!user) {
        return null;
    }

    let role = getUserRole(user);

    if (role !== UserRole.Administrator &&
        role !== UserRole.Forwarder) {
        return null;
    }

    return (
        <SidebarButton id={'sidebar-sanctions-check-item'}
            type={'secondary'}
            text={t("shared.btn.sanctions-check")}
            title={t("shared.btn.sanctions-check")}
            onClick={async () => {

                let link = await getSanctionsCheckLink();

                if (link != null) {
                    window.open(link.data.data, '_blank');
                }
            }}
        />
    );
};

export default SidebarMenuSanctionsCheck;
